import React from "react";
import "./styles/surmayee.css";
import {
  BrowserRouter,
  Link,
  Navigate,
  NavLink,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Blog from "./pages/Blog";
import Experience from "./pages/Experience";
import Education from "./pages/Education";
import Extracurriculars from "./pages/Extracurriculars";
import { Toaster } from "./components/ui/toaster";
import GlobalBackgroundAnimation from "./components/GlobalBackgroundAnimation";
import { person } from "./mock";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function TopNav() {
  const linkClass = ({ isActive }) =>
    `luxe-nav__link ${isActive ? "luxe-nav__link--active" : ""}`;

  const [show, setShow] = React.useState(() => window.scrollY < 8);

  React.useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        setShow(window.scrollY < 8);
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div
      className={`luxe-nav ${show ? "luxe-nav--show" : "luxe-nav--hide"}`}
      role="navigation"
      aria-label="Primary"
    >
      <Link to="/" className="luxe-nav__brand">
        AMRITH PAWAR PORTFOLIO
      </Link>

      <div className="luxe-nav__links">
        <NavLink to="/" className={linkClass} end>
          Home
        </NavLink>
        <NavLink to="/experience" className={linkClass}>
          Experience
        </NavLink>
        <NavLink to="/education" className={linkClass}>
          Education
        </NavLink>
        <NavLink to="/projects" className={linkClass}>
          Projects
        </NavLink>
        <NavLink to="/extracurriculars" className={linkClass}>
          Extracurriculars
        </NavLink>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <GlobalBackgroundAnimation />
        <TopNav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/education" element={<Education />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/extracurriculars" element={<Extracurriculars />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
